import { useCallback } from 'react';

import { AnalyzeWithOpsPilotProps } from '@cast/design-system';

import { useCurrentOrganization } from '@cast/infrastructure-organization';

import { useChatbotState } from './useChatbotState';
import { useIsOpsPilotEnabled } from '../../hooks/useIsOpsPilotEnabled';

type UseAnalyzeWithOpsPilotOptions = {
  buildPrompt?: (range?: { from: number; to: number }) => string | null;
};

export function useAnalyzeWithOpsPilot(
  options: UseAnalyzeWithOpsPilotOptions
): AnalyzeWithOpsPilotProps | undefined {
  const { opsPilotStatus } = useIsOpsPilotEnabled();
  const { id: orgId } = useCurrentOrganization();
  const open = useChatbotState((state) => state.open);
  const { buildPrompt } = options;

  const getPrompt = useCallback(
    (zoomedRange?: { from: number; to: number }) =>
      buildPrompt?.(zoomedRange) ?? null,
    [buildPrompt]
  );

  const onClick = useCallback(
    (prompt: string) => open(orgId, prompt),
    [open, orgId]
  );

  if (opsPilotStatus !== 'on' || !buildPrompt) return undefined;

  return { getPrompt, onClick };
}
